function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C",
  x: 0.5,
  y: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "15.79%",
  y1: "14.74%",
  x2: "91.00%",
  y2: "85.23%",
  id: "A"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "82.14%",
  y1: "85.24%",
  x2: "-3.11%",
  y2: "14.79%",
  id: "B"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#fff"
})));

var _ref4 = /*#__PURE__*/React.createElement("symbol", {
  id: "C",
  overflow: "visible"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.983 9.078q0 1.19-.336 1.939-.336.75-1.371 1.242 1.034.464 1.371 1.242.336.75.336 1.914v4.577q0 1.242.464 1.758.464.543 1.603.543h2.095q.646 0 .646.647v.672q0 .646-.646.646H9.05q-2.276 0-3.284-.983-.983-.983-.983-3.284v-4.577q0-1.164-.464-1.655-.464-.517-1.604-.517H.647q-.646 0-.646-.646v-.672q0-.646.647-.646h2.069q1.138 0 1.604-.517.464-.517.464-1.683V4.524q0-2.302.983-3.284Q6.774.257 9.05.257h2.095q.646 0 .646.647v.672q0 .647-.646.647H9.05q-1.138 0-1.603.543-.464.543-.464 1.758zM27.821 0q.646 0 .646.647v1.707q0 .646-.646.646h-1.683q-.646 0-.646-.646V.647q0-.646.646-.646zm0 6.724q.646 0 .646.646v9.181q0 3.802-1.784 5.509-1.758 1.734-4.5 1.734-2.043 0-3.881-.776-.412-.155-.412-.543 0-.155.078-.31l.259-.621q.155-.412.543-.412.181 0 .284.051 1.629.595 3.129.595 1.888 0 2.974-1.19 1.086-1.19 1.086-4.034v-7.81h-7.216q-.646 0-.646-.647v-.726q0-.647.646-.647zm19.85 1.474q-.155.569-.776.464-1.474-.233-2.328-.233-1.293 0-2.172.44-.879.412-.879 1.19 0 .672.698 1.19.698.517 1.94.672 2.302.284 3.414 1.345 1.138 1.06 1.138 2.61 0 1.81-1.422 2.922-1.422 1.112-4.009 1.112-1.734 0-3.491-.285-.543-.078-.543-.569 0-.129.026-.207l.155-.672q.103-.595.75-.517 1.5.259 3.103.259 1.552 0 2.379-.569.853-.569.853-1.474 0-.75-.647-1.293-.621-.543-1.965-.672-2.146-.207-3.362-1.267-1.215-1.086-1.215-2.586 0-1.578 1.319-2.586 1.319-1.009 3.672-1.009 1.526 0 3.051.285.517.078.517.569 0 .129-.026.207zm32.666-.724q0-.569.595-.698 2.069-.31 4.396-.31 2.897 0 4.19 1.215 1.293 1.19 1.293 4.009v7.319q0 .646-.647.646h-.905q-.647 0-.647-.646V11.69q0-1.81-.75-2.535-.75-.724-2.535-.724-1.242 0-2.793.103v10.474q0 .646-.647.646h-.905q-.647 0-.647-.646zm21.485-2.948q0-1.215-.464-1.758-.464-.543-1.603-.543h-2.095q-.647 0-.647-.647V.905q0-.647.647-.647h2.095q2.276 0 3.258.983 1.009.983 1.009 3.284v4.552q0 1.164.464 1.683.464.517 1.603.517h2.069q.647 0 .647.646v.673q0 .646-.647.646h-2.069q-1.138 0-1.603.517-.464.491-.464 1.655v4.577q0 2.302-.983 3.284-.983.983-3.284.983h-2.095q-.647 0-.647-.647v-.672q0-.646.647-.646h2.095q1.138 0 1.603-.543.464-.517.464-1.758v-4.577q0-1.164.336-1.914.336-.776 1.371-1.242-1.034-.491-1.371-1.242-.336-.75-.336-1.94z",
  fill: "var(--color-text)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.166 16.729c3.555 4.846 7.033-1.353 7.029-5.08-.007-4.407-4.474-6.87-7.032-6.87-4.106 0-8.017 3.394-8.017 8.037 0 5.161 4.483 8.02 8.017 8.02-.8-.115-3.465-.686-3.501-6.825-.024-4.152 1.354-5.811 3.495-5.081.048.018 2.361.93 2.361 3.911 0 2.968-2.353 3.888-2.353 3.888z",
  fill: "url(#A)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.162 8.926c-2.349-.809-5.226 1.126-5.226 5.004 0 6.331 4.691 6.906 5.26 6.906 4.106 0 8.017-3.394 8.017-8.037 0-5.161-4.483-8.02-8.017-8.02.979-.136 5.276 1.059 5.276 6.933 0 3.83-3.209 5.915-5.296 5.024-.048-.018-2.361-.93-2.361-3.911 0-2.968 2.346-3.898 2.346-3.898z",
  fill: "url(#B)"
})));

function SvgJson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 110 26",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/json.68d32f49.svg";
export { ForwardRef as ReactComponent };